/**
 * Regional default for the phone country-code selector.
 *
 * The widget serves shoppers in many countries; a hardcoded +27 default made
 * every non-South-African visitor scroll the dropdown. Resolution order:
 *   1. visitorCountry — the ISO2 country Vercel geo-resolves from the
 *      visitor's IP (`x-vercel-ip-country`), served by api/config-chat-widget.
 *   2. The browser locale's region tag ("pt-PT" → PT).
 *   3. "27" — the historical default, unchanged for anyone we can't place.
 */
import { countryCodes } from "../data/CountryCodes";

export function dialCodeForCountry(iso2?: string | null): string | null {
  if (!iso2) return null;
  const hit = countryCodes.find((c) => c.iso2 === iso2.toLowerCase());
  return hit ? hit.code : null;
}

export function localeCountry(): string | null {
  try {
    const loc = (navigator.language || "").split(";")[0];
    const m = /-([A-Za-z]{2})\b/.exec(loc);
    return m ? m[1] : null;
  } catch {
    return null;
  }
}

export function defaultDialCode(visitorCountry?: string | null): string {
  return (
    dialCodeForCountry(visitorCountry) ||
    dialCodeForCountry(localeCountry()) ||
    "27"
  );
}
